import { useEffect } from 'react';

const SchemaOrg = () => {
  const siteUrl = (import.meta.env.VITE_SITE_URL as string) || 'https://example.com';

  useEffect(() => {
    const webPageSchema = {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${siteUrl}/#webpage`,
      url: siteUrl,
      name: 'Polar Clim – Expert Climatisation Pompe à Chaleur Nice et Environs',
      description:
        'Polar Clim, expert certifié en climatisation et pompe à chaleur à Nice. Installation, maintenance et dépannage de systèmes thermiques. Devis gratuit sous 24h. Zone Nice et environs.',
      inLanguage: 'fr-FR',
      isPartOf: { '@id': `${siteUrl}/#website` },
      about: { '@id': `${siteUrl}/#localbusiness` },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Accueil',
            item: siteUrl,
          },
        ],
      },
      dateModified: '2026-03-23',
      primaryImageOfPage: {
        '@type': 'ImageObject',
        url: 'https://public.readdy.ai/ai/img_res/784e597e-453e-4120-a0b9-90af86a62c15.png',
      },
    };

    const localBusinessSchema = {
      '@context': 'https://schema.org',
      '@type': 'HVACBusiness',
      '@id': `${siteUrl}/#localbusiness`,
      name: 'Polar Clim',
      description:
        'Spécialiste certifié en climatisation et pompes à chaleur à Nice et dans les Alpes-Maritimes. Installation, maintenance préventive, dépannage, PAC, VMC/CTA et bilan énergétique.',
      url: siteUrl,
      telephone: '+33651341160',
      email: 'Horn@gmx.fr',
      image: 'https://public.readdy.ai/ai/img_res/784e597e-453e-4120-a0b9-90af86a62c15.png',
      logo: 'https://public.readdy.ai/ai/img_res/784e597e-453e-4120-a0b9-90af86a62c15.png',
      priceRange: '€€',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '5 Place de la Victoire',
        postalCode: '06440',
        addressLocality: 'Blausasc',
        addressRegion: 'Alpes-Maritimes',
        addressCountry: 'FR',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 43.7102,
        longitude: 7.262,
      },
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
          opens: '08:00',
          closes: '20:00',
        },
      ],
      areaServed: [
        { '@type': 'City', name: 'Nice' },
        { '@type': 'City', name: 'Antibes' },
        { '@type': 'City', name: 'Cannes' },
        { '@type': 'City', name: 'Menton' },
        { '@type': 'City', name: 'Grasse' },
        { '@type': 'City', name: 'Cagnes-sur-Mer' },
        { '@type': 'City', name: 'Saint-Laurent-du-Var' },
        { '@type': 'City', name: 'Vence' },
        { '@type': 'City', name: 'Villeneuve-Loubet' },
        { '@type': 'AdministrativeArea', name: 'Alpes-Maritimes' },
      ],
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Services Climatisation & PAC',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Installation climatisation sur mesure',
              description:
                'Étude personnalisée et installation de systèmes de climatisation adaptés à votre espace.',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Maintenance préventive climatisation',
              description:
                'Entretien complet de vos équipements pour assurer leur longévité et leurs performances.',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Dépannage climatisation',
              description:
                'Intervention rapide pour diagnostiquer et résoudre toute panne de climatisation.',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Installation pompe à chaleur (PAC)',
              description:
                'Installation et entretien de pompes à chaleur air/air et air/eau à Nice et environs.',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'VMC et CTA',
              description:
                'Pose et entretien de systèmes de ventilation mécanique contrôlée et centrales de traitement d\'air.',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Bilan énergétique',
              description:
                'Analyse de votre installation pour optimiser votre consommation et améliorer votre confort.',
            },
          },
        ],
      },
    };

    const webSiteSchema = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      name: 'Polar Clim',
      url: siteUrl,
      description:
        'Site officiel de Polar Clim – Expert en climatisation et pompes à chaleur à Nice et dans les Alpes-Maritimes.',
      inLanguage: 'fr-FR',
    };

    const injectScript = (id: string, data: object) => {
      const existing = document.getElementById(id);
      if (existing) existing.remove();
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = id;
      script.text = JSON.stringify(data);
      document.head.appendChild(script);
    };

    injectScript('schema-local-business', localBusinessSchema);
    injectScript('schema-website', webSiteSchema);
    injectScript('schema-webpage', webPageSchema);

    return () => {
      document.getElementById('schema-local-business')?.remove();
      document.getElementById('schema-website')?.remove();
      document.getElementById('schema-webpage')?.remove();
    };
  }, [siteUrl]);

  return null;
};

export default SchemaOrg;
